import {useState, useEffect} from "react";
import {Collapse} from "react-bootstrap";
import {twMerge} from "tailwind-merge";

const SubCategoryDrop = ({category, subCatIds, setSubCatIds}) => {
  const {title, SubCategories} = category;

  // State to track the list of subcategories being checked
  const [subCheckedState, setSubCheckedState] = useState([]);
  const [collapse, setCollapse] = useState(true);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);

  useEffect(() => {
    if (SubCategories.length) {
      setSubCheckedState([
        ...SubCategories.map((ele) => {
          if (subCatIds.includes(ele.id)) {
            return {checked: true, id: ele.id};
          }
          return {checked: false, id: ele.id};
        }),
      ]);
    }
  }, [subCatIds, SubCategories]);

  useEffect(() => {
    return () => {
      setSubCatIds((prev) => {
        const newSet = new Set(prev);
        SubCategories.forEach((ele) => newSet.delete(ele.id));

        return newSet;
      });
    };
  }, []);

  // Handle when an individual subcategory checkbox is clicked
  const handleSubCategoryCheck = (index, id) => {
    const updatedCheckedState = [...subCheckedState];
    if (!updatedCheckedState[index].checked) {
      setSubCatIds((prev) => {
        const newSet = new Set(prev);
        newSet.add(id);
        return newSet;
      });
    } else {
      setSubCatIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });
    }
    updatedCheckedState[index].checked = !updatedCheckedState[index].checked;

    setSubCheckedState(updatedCheckedState);
  };

  // Handle when the main category (title) checkbox is clicked
  const handleTitleCheck = () => {
    const newState = !isAllChecked;
    if (newState)
      setSubCheckedState((prev) => [
        ...prev.map((ele) => {
          return {...ele, checked: newState};
        }),
      ]);
    setIsAllChecked(newState);

    setIsIndeterminate(false);
    if (newState) {
      setSubCatIds((prev) => {
        const newSet = new Set(prev);
        subCheckedState.forEach((ele) => newSet.add(ele.id));
        return newSet;
      });
    } else {
      setSubCatIds((prev) => {
        const newSet = new Set(prev);
        subCheckedState.forEach((ele) => newSet.delete(ele.id));
        return newSet;
      });
    }
  };

  // Update the title checkbox state based on the list checkboxes
  useEffect(() => {
    const allChecked = subCheckedState.every((ele) => ele.checked);
    const someChecked = subCheckedState.some((ele) => ele.checked);

    setIsAllChecked(allChecked);

    setIsIndeterminate(!allChecked && someChecked);
  }, [subCheckedState]);

  return (
    <div className="w-full">
      <div
        className="cursor-pointer flex justify-start gap-2 items-center"
        onClick={() => setCollapse((prev) => !prev)}
      >
        <input
          id={title}
          type="checkbox"
          className="hidden peer after:!hidden "
          checked={isAllChecked}
          onChange={handleTitleCheck}

          // ref={(input) => input && (input.indeterminate = isIndeterminate)}
        />
        <label
          htmlFor={title}
          className={` after:font-[FontAwesome]  after:peer-checked:!content-['\\f00c']  after:text-white  flex items-center justify-center w-7 h-7 !min-w-5 !m-0   border-2 border-gray-200 rounded-lg cursor-pointer    peer-checked:!bg-[#1A64B9] 
              ${isIndeterminate ? " text-white !bg-[#1A64B9]" : "bg-white "} `}
        >
          {isIndeterminate && <span className="text-lg font-bold">—</span>}
          {isAllChecked && (
            <span className="text-lg font-bold text-white">
              <i className="fi fi-br-check flex items-center"></i>
            </span>
          )}
        </label>
        <span>{title}</span>
      </div>
      <Collapse in={true}>
        <ul className={`${true ? "mm-show" : ""} ml-4 mt-2 `}>
          {!!SubCategories?.length &&
            SubCategories.map((subCat, index) => (
              <li
                key={index}
                className="flex justify-start gap-2 items-center mb-1 "
              >
                <input
                  type="checkbox"
                  id={subCat.title}
                  className="hidden peer after:!hidden"
                  checked={subCheckedState[index]?.checked}
                  onChange={() => handleSubCategoryCheck(index, subCat.id)}
                />
                <label
                  htmlFor={subCat.title}
                  className=" after:font-[FontAwesome] after:peer-checked:content-['\f00c'] after:text-white flex items-center justify-center w-6 h-6 !min-w-5 !m-0  bg-white border-2 border-gray-200 rounded-lg cursor-pointer    peer-checked:!bg-[#1A64B9] "
                ></label>
                <span>{subCat.title}</span>
              </li>
            ))}
        </ul>
      </Collapse>
    </div>
  );
};

export default SubCategoryDrop;
